export const SUITE_USER_PROFILE_QUERY_KEYS = {
  keys: {
    profile: () => ['suite-user-profile'] as const
  }
}
